type CopyProps = {
  className: string;
  color?: string;
};

export default function Copy(props: CopyProps) {
  const color = props.color ?? "#003399";
  const className = props.className ?? "";
  return (
    <div className={className}>
      <svg
        style={{ width: "inherit", height: "inherit" }}
        viewBox="0 0 701 701"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M599.441 700.83H17.6016C15.3031 700.831 13.0271 700.379 10.9033 699.5C8.77953 698.622 6.84892 697.333 5.22364 695.707C3.59835 694.082 2.30966 692.152 1.43067 690.028C0.551675 687.905 0.100251 685.628 0.101565 683.33V101.48C0.101565 96.8387 1.94468 92.3874 5.22657 89.1055C8.50845 85.8236 12.9603 83.98 17.6016 83.98H599.441C604.083 83.98 608.534 85.8236 611.815 89.1055C615.097 92.3874 616.941 96.8387 616.941 101.48V683.37C616.933 688.005 615.086 692.448 611.805 695.721C608.523 698.995 604.077 700.833 599.441 700.83ZM35.1016 665.83H581.941V118.98H35.1016V665.83Z"
          fill={color}
        />
        <path
          d="M682.601 617.68H599.44C594.8 617.678 590.351 615.833 587.069 612.552C583.788 609.27 581.943 604.821 581.94 600.18C581.94 595.539 583.785 591.088 587.066 587.806C590.348 584.524 594.799 582.68 599.44 582.68H665.101V35.8301H118.25V101.48C118.25 106.122 116.407 110.573 113.125 113.854C109.843 117.136 105.391 118.98 100.75 118.98C98.4515 118.982 96.1756 118.53 94.0518 117.651C91.928 116.772 89.9983 115.483 88.373 113.857C86.7478 112.232 85.4591 110.303 84.5801 108.179C83.7011 106.055 83.2487 103.779 83.25 101.48V18.3701C83.25 13.7288 85.0941 9.27774 88.376 5.99585C91.6579 2.71396 96.1087 0.870117 100.75 0.870117H682.601C687.241 0.872767 691.69 2.71747 694.972 5.99878C698.253 9.28009 700.098 13.7296 700.101 18.3701V600.22C700.087 604.854 698.238 609.293 694.958 612.566C691.678 615.838 687.234 617.678 682.601 617.68Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
